import OnboardMultipleStudentsPopup from "../students/multiple/onboardMultipleStudentsPopup"
import OnboardSingleStudentPopup from "../students/onboardSingleStudentPopup"
import StudentActionPopups from "../students/studentActionPopups"

// Onboarding is program-scoped and lives only here; every per-student action
// popup comes from the shared host, so the program page and the students page
// can never drift apart on which actions they can actually open.
function OnboardStudentsDialogPresenter() {
  return (
    <>
      <OnboardSingleStudentPopup />
      <OnboardMultipleStudentsPopup />
      <StudentActionPopups />
    </>
  )
}

export default OnboardStudentsDialogPresenter
